export interface GroupsWhatsNewStep {
  id: string;
  label: string;
  title: string;
  description: string;
  bullets: string[];
  iconPaths: string[];
}

export const GROUPS_WHATS_NEW_STEPS: readonly GroupsWhatsNewStep[] = [
  {
    id: 'organise',
    label: 'Your groups',
    title: 'Build shortlists that live in one place',
    description: 'Groups now has its own spot in the main navigation, so every shortlist you build is one click away.',
    bullets: [
      'Keep a group private to you, or make it visible to your whole brand team.',
      'Add creators to a group from any creator profile while you search.',
      'SHOUT builds an Interested Creators group from creators who ask to work with you.',
    ],
    iconPaths: [
      'M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z',
    ],
  },
  {
    id: 'share',
    label: 'Sharing',
    title: 'Send a shortlist to anyone for review',
    description: 'Open a group, choose Share for review, then copy the link or email it straight to a colleague.',
    bullets: [
      "Reviewers don't need a SHOUT account — the link opens a public review page.",
      'Email a colleague directly and add a note explaining what you need from them.',
      'The share link stays live, so you can send it to as many people as you like.',
    ],
    iconPaths: ['M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8', 'm16 6-4-4-4 4', 'M12 2v13'],
  },
  {
    id: 'review',
    label: 'Feedback',
    title: 'Collect a decision on every creator',
    description: 'Reviewers work through the shortlist one creator at a time and record what they think.',
    bullets: [
      "Approve or decline any creator, with the reviewer's name captured automatically.",
      "Leave written feedback when the answer isn't a straight yes or no.",
      'Every decision shows back on your group, so you always know who said what.',
    ],
    iconPaths: ['M7.9 20A9 9 0 1 0 4 16.1L2 22Z'],
  },
  {
    id: 'auto-invite',
    label: 'Auto-invite',
    title: 'Turn approvals into brief invites',
    description: 'Pick a brief when you share a group and approved creators get invited without you lifting a finger.',
    bullets: [
      'Switch on Invite Creators Automatically in the share dialog.',
      'Choose which brief approved creators should be invited to.',
      'Invites only fire when a reviewer approves, not when the link is opened.',
    ],
    iconPaths: ['m22 2-7 20-4-9-9-4Z', 'M22 2 11 13'],
  },
  {
    id: 'filter',
    label: 'Filter & invite',
    title: 'Cut through a long list, then invite in bulk',
    description: 'Review tabs help you focus on what still needs attention before you invite anyone.',
    bullets: [
      'Switch between All, Needs review, Approved, Declined and Feedback.',
      'Select several creators and use Invite Selected to send one batch of invites.',
      "Remove anyone who's no longer a fit straight from their card.",
    ],
    iconPaths: ['M3 6h18', 'M7 12h10', 'M10 18h4'],
  },
];
